import { render, staticRenderFns } from "./information-change-conclusion.vue?vue&type=template&id=553ca167&scoped=true"
import script from "./information-change-conclusion.vue?vue&type=script&lang=js"
export * from "./information-change-conclusion.vue?vue&type=script&lang=js"
import style0 from "./information-change-conclusion.vue?vue&type=style&index=0&id=553ca167&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ca167",
  null
  
)

export default component.exports